<script>
import {
  ArrowUpIcon,
} from "vue-feather-icons";
import appConfig from "@/app.config";
import axios from 'axios';
import VueEasyLightbox from "vue-easy-lightbox";
import MenuBar from './MenuBar.vue'
import { Editor, EditorContent, FloatingMenu } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Text from '@tiptap/extension-text'
import TextStyle from "@tiptap/extension-text-style";
import Highlight from '@tiptap/extension-highlight'
import TextAlign from '@tiptap/extension-text-align'
import Placeholder from '@tiptap/extension-placeholder'
import Mention from '@tiptap/extension-mention'
import Color from '@tiptap/extension-color'
import Link from '@tiptap/extension-link'
import Image from '@tiptap/extension-image'
import Youtube from '@tiptap/extension-youtube'
import Underline from '@tiptap/extension-underline'
import FontSize from 'tiptap-extension-font-size'
import Table from '@tiptap/extension-table'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'
import Focus from '@tiptap/extension-focus'
import suggestion from '@tiptap/suggestion'
//import Float from "tiptap-extension-float";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import FloatExtension from "./imageFloat"; // 이미지 정렬

// 초기세팅
function initialState() {
  return {
    token: "",
    login: {
      idx: 0,
      level: 0,
      nick: "",
      isLogin: false,
    },
    use_editor: true,
    wTitle: "", // 글제목
    contents: "",
    wr_name: "",
    wr_password: "",
    wr_email: "",
    wr_phone: "",
    is_notice: false,
    is_temp_save: false,
    editor: null,
    imageSrc: "",
    movieSrc: "",
    command: null,
    filelist: [], // 첨부할 때 사용하는 파일 리스트
    tempFiles: [], // 이 게시물의 임시 파일 리스트
    thisFiles: [], // 이 게시물의 최종 파일 리스트
    uploadingSpinner: false,
    isSaving: false, // 저장 중 플래그 (중복 호출 방지)
    keydownHandler: null, // 이벤트 리스너 참조 저장 (중복 등록 방지)
  };
}

export default {
  components: {
    VueEasyLightbox,
    ArrowUpIcon,
    EditorContent,
    FloatingMenu,
    MenuBar,
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      appConfig: appConfig,
      ...initialState(),
    };
  },
  props: {
    bi: {
      type: Number,
    },
    wi: {
      type: Number,
    },
    page: {
      type: Number,
    },
    work: {
      type: String,
    },
    writeData: {
      type: Object,
    },
    baseInfo: {
      type: Object,
    },
    boardInfo: {
      type: Object,
    },
    thisBoard: {
      type: Object,
    },
  },
  computed: {
    // 확장자 검사
    validImage() {
      return (
        this.imageSrc.match(/unsplash/) !== null ||
        this.imageSrc.match(/\.(jpeg|jpg|gif|png|JPG|JPEG|PNG|GIF)(\?.*)?$/i) !== null // ? 뒤에꺼 무시
      );
    },
  },
  metaInfo() {
    // 게시판 이름
    const boardName = this.thisBoard && this.thisBoard.jsonData && this.thisBoard.jsonData.name 
      ? this.thisBoard.jsonData.name 
      : '게시판';
    
    const workType = this.work === 'm' ? '수정' : '작성';
    const title = `${boardName} 글${workType} | 대구여성인권센터`;
    const description = `${boardName} 게시판에 글을 ${workType}하는 페이지입니다.`;
    
    return {
      title: title,
      meta: [
        {
          name: 'description',
          content: description
        },
        {
          property: 'og:title',
          content: title
        },
        {
          property: 'og:description',
          content: description
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          name: 'twitter:title',
          content: title
        },
        {
          name: 'twitter:description',
          content: description
        }
      ]
    }
  },
  watch: {
    writeData: function() {
      if (this.writeData.contents) {
        this.contents = this.writeData.contents
        this.wTitle = this.writeData.subject
        this.wr_name = this.writeData.wr_name
        this.wr_email = this.writeData.wr_email
        this.wr_phone = this.writeData.wr_phone
        this.is_notice = this.writeData.is_notice
        this.thisFiles = this.writeData.file_json
        this.is_temp_save = this.writeData.is_temp_save
      }
      this.contentsToEditor()
    },
  },
  mounted() {
    // 임시저장 후 리플레시 시 스크롤 위치 복원
    try {
      const saved = sessionStorage.getItem('jy_board_write_scroll_y');
      if (saved != null) {
        sessionStorage.removeItem('jy_board_write_scroll_y');
        const y = parseInt(saved, 10);
        if (!isNaN(y) && y >= 0) {
          this.$nextTick(() => {
            setTimeout(() => {
              window.scrollTo(0, y);
            }, 150);
          });
        }
      }
    } catch (e) {}
  },
  beforeUnmount() {
    this.editor.destroy()
  },
  created() {
    this.first()
  },
  methods: {
    // 처음에 실행되는 부분
    first() {
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token
        // 레벨 90 이상이면 백엔드로 한 번더 검증
        if (this.login.level > 90) {
          this.r_is_admin(); // admin-setting 참고
        }
      }
    },
    contentsToEditor() {
      // 에디터 선언
      this.editor = new Editor({
        content: this.contents,
        extensions: [
          StarterKit,
          TextStyle,
          Highlight,
          Underline,
          Color,
          Mention.configure({
            suggestion: {
              char: "",
            },
            HTMLAttributes: {
              class: 'btn mention',
            },
            renderText({ options, node }) {
              return `${options.suggestion.char}${node.attrs.label ?? node.attrs.id}`
            },
            deleteTriggerWithBackspace: true
          }),
          FontSize,
          Link.configure({
            openOnClick: false,
          }),
          Focus.configure({
            className: 'has-focus',
            mode: 'all',
          }),
          Table.configure({
            resizable: true,
          }),
          TableRow,
          TableHeader,
          TableCell,
          Placeholder.configure({
            placeholder: '내용을 입력해주세요...',
            emptyEditorClass: 'is-editor-empty',
          }),
          TextAlign.configure({
            types: ['heading', 'paragraph'],
            defaultAlignment: 'left',
            alignments: ['left', 'center', 'right'],
          }),
          Image.configure({
            allowBase64: true,
            inline: true,
            HTMLAttributes: {
              //style: "float: left",
            },
          }),
          /*
          Float.configure({
            types: ["image"], // Allow float node types
          }),
          */
          FloatExtension,
          Youtube.configure({
            width: 480,
            height: 320,
            nocookie: false,
            allowFullscreen: false,
            autoplay: true,
            ccLanguage: 'ko',
            interfaceLanguage: 'ko',
            ccLoadPolicy: true,
            disableKBcontrols: true,
            enableIFrameApi: true,
            loop: true,
          }),
        ],
        onUpdate: ({ editor }) => {
          this.contents = editor.getHTML();
        }
      })
    },
    // 관리자 권한 있는 사람인지 확인
    async r_is_admin() {
      try {
        await axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/r_is_admin',
          headers: {
            'access-token': this.token
          },
          data: {
            "mb_idx": this.login.idx,
            "token": this.token,
          },
        })
        .then((res) => {
          if (res.data.type=='success') {
            this.login.isLogin = true
          } else {
            this.login.isLogin = false
            localStorage.removeItem('user');
            this.$store.commit("setAuthIdx", "")
            this.$store.commit("setAuthAccessToken", "")
            this.$store.commit("setAuthNick", "")
            this.$store.commit("setAuthLevel", 0)
            this.$store.commit("setAuthIsLogin", false)
            this.$store.commit("setAuthEmail", "")
            this.$router.go("/");
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.text })
            this.login.isLogin = false
            localStorage.removeItem('user');
            this.$store.commit("setAuthIdx", "")
            this.$store.commit("setAuthAccessToken", "")
            this.$store.commit("setAuthNick", "")
            this.$store.commit("setAuthLevel", 0)
            this.$store.commit("setAuthIsLogin", false)
            this.$store.commit("setAuthEmail", "")
            this.$router.go("/");
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
        this.login.isLogin = false
        localStorage.removeItem('user');
        this.$store.commit("setAuthIdx", "")
        this.$store.commit("setAuthAccessToken", "")
        this.$store.commit("setAuthNick", "")
        this.$store.commit("setAuthLevel", 0)
        this.$store.commit("setAuthIsLogin", false)
        this.$store.commit("setAuthEmail", "")
        this.$router.go("/");
      }
    },
    // 저장전에 검증먼저하고 보내주자
    saveWrite() {
      // 이미 저장 중이면 중복 호출 방지
      if (this.isSaving) {
        return;
      }
      // 비회원 상태
      if (this.login.idx == 0) {
        if (this.wr_name=='' || this.wr_password=='' || this.wTitle=='') {
          this.$notify({ type: 'error', duration: 5000, title: '실패', text: '필수항목을 기입해주세요 (글쓴이, 비밀번호 6자리, 제목)'})
        } else {
          if (this.wr_password.length < 6) {
            this.$notify({ type: 'error', duration: 3000, title: '실패', text: `비밀번호는 최소 6자리 이상이어야 합니다.`})
          } else {
            // 비밀번호 동일한 글자 4개 이상 금지 검사 & 123456 금지
            const repeatedCharPattern = /(.)\1\1\1/;
            const forbiddenPattern = /123456/;
            if (repeatedCharPattern.test(this.wr_password) || forbiddenPattern.test(this.wr_password)) {
              this.$notify({ type: 'error', duration: 3000, title: '실패', text: `비밀번호에 동일한 글자를 4개 이상 사용할 수 없습니다. 또는 123456 금지입니다.`})
            } else {
              this.okSaveWrite();
            }
          }
        }
      } else { // 회원
        if (this.wTitle=='') {
          this.$notify({ type: 'error', duration: 3000, title: '실패', text: '필수항목을 기입해주세요'})
        } else {
          this.okSaveWrite();
        }
      }
    },
    // 임시 저장하기
    imsiSave() {
      // 이미 저장 중이면 중복 호출 방지
      if (this.isSaving) {
        return;
      }
      // 임시 저장은 로그인한 회원만 가능
      if (this.login.idx == 0) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '임시 저장은 로그인한 회원만 가능합니다.'})
        return;
      }
      // 비밀게시판에서는 임시 저장 불가
      if (this.thisBoard && this.thisBoard.jsonData && this.thisBoard.jsonData.use_secret == true) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '비밀게시판에서는 임시 저장이 불가능합니다.'})
        return;
      }
      if (!this.writeData) {
        this.writeData = {};
      }
      // input 필드에서 최신 제목 값 가져오기 (Ctrl+S 시 반영되지 않은 값 방지)
      const titleInput = document.getElementById('wTitleInput');
      if (titleInput) {
        this.wTitle = titleInput.value;
      }

      // 제목이 없어도 임시 저장 가능하도록 처리
      if (this.wTitle == '') {
        this.wTitle = '임시저장_' + new Date().toLocaleString('ko-KR');
      }
      // 임시 저장 표시
      this.is_temp_save = true;
      // 실제 저장
      this.saveWrite();
    },
    // 저장 하기
    okSaveWrite() {
      // 이미 저장 중이면 중복 호출 방지
      if (this.isSaving) {
        console.log('이미 저장 중입니다. 중복 호출을 방지합니다.');
        return;
      }
      // 플래그를 가장 먼저 설정하여 중복 호출 방지
      this.isSaving = true;
      try {
        // 에디터에서 최신 내용 가져오기 (항상 최신 상태 보장)
        let latestContents = this.contents;
        if (this.editor) {
          latestContents = this.editor.getHTML();
          // this.contents도 동기화
          this.contents = latestContents;
        }
        
        // input 필드에서 최신 제목 값 가져오기
        const titleInput = document.getElementById('wTitleInput');
        let latestTitle = this.wTitle;
        if (titleInput) {
          latestTitle = titleInput.value;
          this.wTitle = latestTitle;
        }
        
        this.loadingBar(true);
        axios({
          method: 'POST',
          url: appConfig.fastapi + '/board/jy_board_write_save',
          headers: {
            'access-token': this.token
          },
          data: {
            "work": this.work,
            "bi": this.bi,
            "wi": this.wi,
            "mb_idx": this.login.idx,
            "mb_nick": this.login.nick,
            "title": latestTitle,
            "contents": latestContents,
            "tempFiles": this.tempFiles,
            "thisFiles": this.thisFiles,
            "is_notice": this.is_notice,
            "is_temp_save": this.is_temp_save,
            "wr_name": this.wr_name,
            "wr_password": this.wr_password,
            "wr_email": this.wr_email,
            "wr_phone": this.wr_phone,
          },
        })
        .then((res) => {
          if (res.data.status) {
            if (res.data.status=='success') {
              // 임시 저장이면 페이지 이동하지 않고 알림만 표시
              if (this.is_temp_save) {
                // 저장된 게시글 다시 가져오자
                this.$notify({ type: 'success', duration: 3000, 'title': '임시 저장 완료', text: '임시 저장되었습니다.'})
                // 새로고침 전에 스크롤 위치 저장 (mounted에서 복구)
                try {
                  sessionStorage.setItem('jy_board_write_scroll_y', String(window.scrollY || window.pageYOffset || 0));
                } catch (e) {}
                this.$router.go(0);
              } else {
                // 글 수정이면 다시 본문으로
                if (this.work=='m') {
                  // 비밀글이었으면 store에 게시글 읽기한다고 정보전달하자
                  this.$store.commit('setBoardSecurity', {
                    "work": 'r',
                    "password": this.wr_password,
                  });
                  this.$router.push({ path: `/jy/${this.bi}/r/${this.wi}`})
                } else {
                  this.$router.push({ path: `/jy/${this.bi}`})
                }
              }
            } else {
              this.$notify({ type: 'error', duration: 3000, 'title': '글 저장 에러', text: "관리자에게 문의해주세요" })
            }
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
          }
        })
        .finally(() => {
          this.loadingBar(false);
          this.isSaving = false; // 저장 완료 플래그 해제
          // 저장성공이면 리스트화면으로 보내주자
          //this.readHistory()
        })
      } catch (error) {
        this.isSaving = false; // 에러 발생 시에도 플래그 해제
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
      }
    },
    parentMethod(command) {
      this.$refs.ytmodal.showModal({command});
    },
    insertImage() {
      // 쿼리 문자열을 제거한 이미지 URL 생성
      const cleanImageSrc = this.imageSrc.split('?')[0];
      this.editor.chain().focus().setImage({ src: cleanImageSrc }).run()
    },
    // editor-main 클릭 시 에디터에 포커스
    focusEditor(event) {
      // editor-content 내부를 클릭한 경우는 기본 동작 유지
      if (event.target.closest('.ProseMirror')) {
        return;
      }
      // editor-main의 빈 영역을 클릭한 경우 에디터에 포커스
      if (this.editor) {
        this.$nextTick(() => {
          this.editor.commands.focus();
        });
      }
    },
    insertMovie() {
      this.editor.commands.setYoutubeVideo({
        src: this.movieSrc,
        width: Math.max(320, parseInt(this.width, 10)) || 640,
        height: Math.max(180, parseInt(this.height, 10)) || 480,
      })
    },
    handleFileUpload() {
      this.filelist = [...this.$refs.fileSinput.files];

      if (this.filelist) {

        // 파일명 기준으로 재정렬시키자
        this.filelist.sort(function(a, b) {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
        });
        const formData = new FormData();
        for (let i = 0; i < this.filelist.length; i++) {
          formData.append('files', this.filelist[i]);  // 'files'와 FastAPI의 필드 이름이 일치해야 합니다.
        }
        formData.append('boardIdx', this.bi); // 게시판idx도 폼데이터에 같이 넣어주자
        //spin 이미지 띄우자
        this.uploadingSpinner = true;
        axios({
          method: 'POST',
          url: appConfig.fastapi + '/board/jy_image_upload',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          if (response.data.status == 'success') {
            if (response.data.files) {
              // 반복문
              response.data.files.forEach((item, index) => {
                // 이미지 경로 지정하고 이미지파일이면 본문에 삽입 (대문자도 처리)
                if (item.ext=='.jpg' || item.ext=='.jpeg' ||item.ext=='.png' ||item.ext=='.gif' || item.ext=='.JPG' || item.ext=='.JPEG' || item.ext=='.PNG' || item.ext=='.GIF') {
                  this.imageSrc = appConfig.fileserver + item.tempUrl;
                  this.insertImage();
                }
                // 첨부파일 리스트에 담자
                const temp = {
                  'tempUrl': item.tempUrl,
                  'name': item.name,
                  'ext': item.ext,
                  'url':appConfig.fileserver + item.tempUrl,
                }
                this.tempFiles.push(temp)
              });
            }
          } else {
            this.$notify({ type: 'error', duration:2000, 'title': '실패', text: '관리자에게 문의해주세요'})
          }
          // spin 이미지 닫자
          this.uploadingSpinner = false;
          // 업로드시킬 파일리스트는 초기화
          this.filelist = [];
          this.imageSrc = '';
          this.$refs.fileSinput.value=null;
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          // 스핀 이미지 닫자
          this.uploadingSpinner = false;
        })
      }
    },
    bFileThisDelete(val) {
      console.log(val)
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains('bg-success')) {
        event.currentTarget.classList.remove('bg-light');
        event.currentTarget.classList.add('bg-success');
      }
    },
    dragleave(event) {
      event.currentTarget.classList.add('bg-light');
      event.currentTarget.classList.remove('bg-success');
    },
    drop(event) {
      event.preventDefault();
      this.$refs.fileSinput.files = event.dataTransfer.files;
      this.handleFileUpload();
      event.currentTarget.classList.add('bg-light');
      event.currentTarget.classList.remove('bg-success');
    },
    // 기다려주세요 loading 처리
    loadingBar(val) {
      if (val === true) {
        document.getElementById("preloader").style.display = "block";
        document.getElementById("status").style.display = "block";
      } else {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }
    },
    fileExtensionCheck(val) {
      // 파일 확장자 추출
      const fileExtension = val.split('.').pop().toLowerCase();
      // 이미지 파일 확장자 목록
      const imageExtensions = ['jpg', 'jpeg', 'gif', 'png'];
      if (imageExtensions.includes(fileExtension)) {
        return 'img'
      } else {
        return fileExtension
      }
    },
    fileListImg(val) {
      return `${appConfig.fileserver}/${this.bi}/${this.wi}/${val}`;
    },
    fileDelete(val1, val2, index) {
      // val1 : tempFiles (업로드파일리스트), thisFiles (기존파일리스트)
      // val2 : 파일명 ex) 202406211250312a8b08bd.png
      if (val2) {
        axios({
          method: 'POST',
          url: appConfig.fastapi + '/board/jy_board_file_delete',
          data: {
            "valueType": val1,
            "valueName": val2,
            "bi": this.bi,
            "wi": this.wi,
          },
        })
        .then((response) => {
          if (response.data.status == 'success') {
            this.$notify({ type: 'success', duration:2000, 'title': '성공', text: response.data.message})
            // 리스트에서도 삭제반영해주자
            if (val1=='tempFiles') {
              this.tempFiles.splice(index, 1);
            } else if (val1=='thisFiles') {
              this.thisFiles.splice(index, 1);
            }            
          } else {
            this.$notify({ type: 'success', duration:2000, 'title': '실패', text: response.data.message})
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
        })
      }
    },
    // 작성일시 임의변경 실행
    updateInsertTime() {
      if (this.writeData.insert_time=='') {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '작성일시를 입력해주세요'})
        return;
      }
      if (this.writeData.insert_time.length != 19) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '작성일시를 올바르게 입력해주세요'})
        return;
      }
      axios({
        method: 'POST',
        url: appConfig.fastapi + '/board/jy_board_update_time_change',
        data: {
          "bi": this.bi,
          "wi": this.wi,
          "insert_time": this.writeData.insert_time,
        },
      })
      .then((response) => {
        console.log(response)
        if (response.data.status == 'success') {
          this.$notify({ type: 'success', duration: 3000, title: '성공', text: '작성일시가 변경되었습니다.'})
        } else {
          this.$notify({ type: 'error', duration: 3000, title: '실패', text: '작성일시 변경에 실패하였습니다.'})
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
      })
    },
  },
}
</script>

<template>
  <div class="row">
    <div class="col-lg-9 col-md-12 col-sm-12">
      <div class="">
        <!-- 비회원일시 작성자 비밀번호 이메일-->
        <div class="card mb-2">
          <!-- 리본 -->
          <div v-if="thisBoard.jsonData" class="ribbon ribbon-left ribbon-primary overflow-hidden">
            <span class="text-center d-block shadow small h6">
              {{ thisBoard.jsonData.name }}
            </span>
          </div>
          <!-- 페이지 가운데로 이동은 justify-content-center -->
          <div v-if="thisBoard.jsonData" class="d-flex align-items-right justify-content-between p-2">
            <div class="">
            </div>
            <div class="">
              <div class="">
                
              </div>
              <ul class="pagination mb-0">
                <li class="page-item">
                  <router-link :to="`/jy/${this.thisBoard.idx}`">
                    <span class="page-link"><i class="mdi mdi-form-select text-warning mr-1"></i>목록으로</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="thisBoard.jsonData" class="p-2">
            <!-- 게시물 영역 -->
            <div class="">
              <!-- 비밀게시판이면 -->
              <div v-if="thisBoard.jsonData.use_secret==true" class="widget pb-2">
                <h5 class="widget-title"></h5>
                <div class="">
                  <div class="alert bg-light">
                    <div class="font-size-14 text-bold text-center text-primary">
                      <div class="text-danger">비밀보장 상담 안내</div>
                      <div class="">상담은 무료로 진행되며,</div>
                      <div class="">글 읽기는 상담사와 본인만 확인 가능합니다.</div>
                      <div class="">상담종료 후 게시글은 파기됩니다.</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 글쓴이, 작성일시, 제목 등 -->
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div v-if="this.login.idx == 0" class="col-md-3">
                      <div class="form-group mb-1">
                        <label for="input_wr_name" class="font-size-12">글쓴이
                          <span class="text-danger">*</span>
                        </label>
                        <div class="position-relative">
                          <input v-model="wr_name" name="input_wr_name" id="input_wr_name" type="text" class="form-control pl-3 font-size-13" placeholder="닉네임 가능" />
                        </div>
                      </div>
                    </div>
                    <div v-if="this.login.idx == 0" class="col-md-3">
                      <div class="form-group mb-1">
                        <label for="input_wr_password" class="font-size-12">비밀번호
                          <span class="text-danger">*</span>
                        </label>
                        <div class="position-relative">
                          <input v-model="wr_password" name="input_wr_password" id="input_wr_password" type="password" placeholder="6자리이상 필수" 
                          class="form-control pl-3 font-size-13" />
                        </div>
                      </div>
                    </div>
                    <div v-if="this.login.idx == 0" class="col-md-6">
                      <div class="form-group mb-1">
                        <label for="input_wr_phone" class="font-size-12">연락처</label>
                        <div class="position-relative">
                          <input v-model="wr_phone" name="input_wr_phone" id="input_wr_phone" type="text" class="form-control pl-3 font-size-13" placeholder="필요시에만 입력해주세요"/>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group mb-1">
                        <label for="wTitleInput" class="font-size-12">글 제목
                          <span class="text-danger">*</span>
                        </label>
                        <b-input id="wTitleInput" v-model="wTitle" placeholder="제목을 여기에 적어주세요" class="font-size-13 text-bold" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-2">
          <!-- 글쓰기 -->
          <div class="editor" v-if="editor">
            <menu-bar class="tiptap-stickybar editor__header" :editor="editor" :thisBoard="thisBoard" />
            <div class="editor-main" @click="focusEditor">
              <editor-content :editor="editor" />
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- 파일 첨부 -->
    <div v-if="thisBoard" class="col-lg-3 col-md-12 col-sm-12">
      <div class="card sidebar sticky-bar">
        <div v-if="thisBoard.jsonData" class="p-3">
          <div v-if="!is_temp_save" class="widget mb-4">
            <b-button @click="saveWrite" class="btn btn-lg btn-blue btn-block">
              저장 하기
            </b-button>
          </div>
          <div v-if="is_temp_save" class="widget mb-4">
            <b-button @click="saveWrite" class="btn btn-lg btn-info btn-block">
              저장 하기 (임시)
            </b-button>
          </div>

          <div class="">

            <div v-if="thisBoard.jsonData.use_notice==true && this.login.idx > 0" class="widget mb-1">
              <div class="">
                <div class="custom-control custom-checkbox">
                  <input v-model="is_notice" type="checkbox" class="custom-control-input" id="is_notice_check" />
                  <label for="is_notice_check" class="custom-control-label font-size-14 font-weight-bold">상단고정 (공지글)</label>
                </div>
              </div>
            </div>

            <!-- 비밀글게시판이 아니며 로그인idx가 0이상이라면 임시저장 가능-->
            <div v-if="thisBoard.jsonData.use_secret==false && this.login.idx > 0" class="widget mb-1">
              <div class="">
                <div class="custom-control custom-checkbox">
                  <input v-model="is_temp_save" type="checkbox" class="custom-control-input" id="is_temp_save_check" />
                  <label for="is_temp_save_check" class="custom-control-label font-size-14 font-weight-bold">임시저장 (노출안됨)</label>
                </div>
              </div>
            </div>
          </div>

          
          
          <div v-if="thisBoard.jsonData.use_secret==false" class="border-bottom mt-3 mb-3"></div>
          <div v-if="thisBoard.jsonData.use_secret==false" class="widget mb-4">
            <span class="font-size-13 text-bold">URL주소로 이미지 넣기</span>
            <div class="mb-0">
              <b-input v-model="imageSrc" id="imgUrlInput" placeholder="https:// 이미지주소" class="font-size-11 text-bold input-square" />
              <b-button
                @click="insertImage"
                class="btn btn-sm btn-primary btn-block btn-square"
                :title="validImage ? '' : '허용된 확장자가 아닙니다.'"
                :disabled="!validImage"
              >
                URl주소로 이미지 넣기
              </b-button>
            </div>
          </div>
          <div v-if="thisBoard.jsonData.use_secret==false" class="border-bottom mt-3 mb-3"></div>
          <div v-if="thisBoard.jsonData.use_secret==false" class="widget mb-4">
            <span class="font-size-13 text-bold">URL주소로 유튜브 넣기</span>
            <div class="mb-0">
              <b-input v-model="movieSrc" id="movieUrlInput" placeholder="https:// 유튜브주소" class="font-size-11 text-bold input-square" />
              <b-button
                @click="insertMovie"
                class="btn btn-sm btn-primary btn-block btn-square"
                :title="movieSrc ? '' : '유튜브주소를 넣어주세요'"
                :disabled="!movieSrc"
              >
                URl주소로 유튜브 넣기
              </b-button>
            </div>
          </div>
          <div class="border-bottom mt-3 mb-3"></div>
          
          <div class="widget mb-4">
            
            <div v-b-tooltip.hover title="허용파일: hwp doc pdf jpg jpeg png gif zip 7z xls xlsx" class="mt-2">
              <span class="font-size-13 text-bold">파일 첨부하기 
                <i class="mdi mdi-information me-1"></i>
              </span>
            </div>

            <div v-if="thisBoard.jsonData" class="mb-0">
              <div class="">
                <label for="FieldfileS" class="p-0 mt-2 mb-2 col-12">
                  <div class="ed-clickable text-center bg-light" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                    <div class="mt-4" v-if="uploadingSpinner === true">
                      <b-spinner class="display-5 text-success" label="Loading"></b-spinner>
                      <h6 class="text-info">업로드중이니 기다려주세요...</h6>
                    </div>
                    <div class="" v-if="uploadingSpinner === false">
                      <i class="display-5 text-primary mdi mdi-file-upload-outline"></i>
                      <h6 class="">클릭 or 끌어서넣기</h6>
                    </div>
                  </div>
                </label>
                <input type="file" multiple name="fields[FieldfileS][]" id="FieldfileS" class="w-px h-px overflow-hidden" @change="handleFileUpload" ref="fileSinput" accept=".hwp,.doc,.pdf,.jpg,.jpeg,.png,.gif,.zip,7z,.xls,.xlsx" />
              </div>
              <div v-if="this.tempFiles.length > 0" class="mb-4 pb-2">
                <span class="font-size-13 text-bold">업로드 첨부파일 리스트</span>
                <div class="row h-100 mx-1">
                  <b-list-group horizontal v-for="(value, key) in tempFiles" :key="key" class="mr-1 mb-1">
                    <div class="">
                      <div v-if="value.ext=='.jpg' || value.ext=='.jpeg' || value.ext=='.png' || value.ext=='.gif' || value.ext=='.JPG' || value.ext=='.JPEG' || value.ext=='.PNG' || value.ext=='.GIF'" class="border-top border-left border-right" v-b-tooltip.hover :title="value.name">
                        <img :src="value.url" class="p-1" width="65" height="65" loading="lazy" />
                      </div>
                      <div v-else class="border" v-b-tooltip.hover :title="value.name">
                        <div class="avatar avatar-small mx-auto d-block text-center">
                          <div class="font-size-13 text-blue">{{ fileExtensionCheck(value.name) }}</div>
                          <div class="font-size-12">일반파일</div>
                        </div>
                      </div>
                      <div @click="fileDelete('tempFiles', value.name, key)" class="bg-soft-danger text-center font-size-11 cursor-pointers">
                        삭제
                      </div>
                    </div>
                  </b-list-group>
                </div>
              </div>
              <div v-if="this.thisFiles.length > 0" class="content mb-4 pb-2">
                <div class="d-flex align-items-right justify-content-between p-">
                  <span class="font-size-13 text-bold">기존 첨부파일 리스트</span>
                </div>
                <div class="row h-100 mx-1">
                  <b-list-group horizontal v-for="(value, key) in thisFiles" :key="key" class="mr-1 mb-1">
                    <div class="">
                      <div v-if="fileExtensionCheck(value) =='img'" class="border-top border-left border-right" v-b-tooltip.hover :title="value">
                        <img :src="fileListImg(value)" class="p-1" width="65" height="65" loading="lazy" />
                      </div>
                      <div v-else class="border-top border-left border-right" v-b-tooltip.hover :title="value">
                        <div class="avatar avatar-small mx-auto d-block text-center">
                          <div class="font-size-13 text-blue">{{ fileExtensionCheck(value) }}</div>
                          <div class="font-size-12">일반파일</div>
                        </div>
                      </div>
                      <div @click="fileDelete('thisFiles', value, key)" class="bg-soft-danger text-center font-size-11 cursor-pointers">
                        삭제
                      </div>
                    </div>
                  </b-list-group>
                </div>
              </div>
              
            </div>
          </div>
          <div class="border-bottom mt-3 mb-3"></div>
          <!-- 글수정 상태일 경우 수정일시 표시하는 폼 나오게 이거 수정하면 작성일자 바꾸는걸루 하게 -->
          <div v-if="this.work=='m' && this.login.level >= 98" class="widget mb-4">
            <div class="">
              <div class="font-size-13 text-bold">
                작성일시 임의변경
                <div class="">
                  <input type="text" v-model="writeData.insert_time" class="form-control form-control-md font-size-12 input-square" />
                  <b-button @click="updateInsertTime" class="btn btn-sm btn-block btn-secondary btn-square">
                    <i class="mdi mdi-update text-warning mr-1"></i>즉시변경
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>